const timetableData = [
  {
    timetable_id: 1616,
    section_id: 2,
    day: "Friday",
    period_id: 12,
    subject_id: 4,
    teacher_id: 6,
    created_at: "2025-07-09T06:39:26.000Z",
    period_name: "Period 2",
    start_time: "10:15:00",
    end_time: "11:00:00",
    subject_name: "hindi",
    section_name: "section 1B",
    class_name: "class 1",
  },
  {
    timetable_id: 1676,
    section_id: 4,
    day: "Friday",
    period_id: 12,
    subject_id: 4,
    teacher_id: 6,
    created_at: "2025-07-09T06:39:26.000Z",
    period_name: "Period 2",
    start_time: "10:15:00",
    end_time: "11:00:00",
    subject_name: "hindi",
    section_name: "class 3 B",
    class_name: "class 3",
  },
  {
    timetable_id: 1678,
    section_id: 4,
    day: "Friday",
    period_id: 15,
    subject_id: 4,
    teacher_id: 6,
    created_at: "2025-07-09T06:39:26.000Z",
    period_name: "Period 4",
    start_time: "12:00:00",
    end_time: "12:45:00",
    subject_name: "hindi",
    section_name: "class 3 B",
    class_name: "class 3",
  },
  {
    timetable_id: 1652,
    section_id: 4,
    day: "Monday",
    period_id: 12,
    subject_id: 4,
    teacher_id: 6,
    created_at: "2025-07-09T06:39:26.000Z",
    period_name: "Period 2",
    start_time: "10:15:00",
    end_time: "11:00:00",
    subject_name: "hindi",
    section_name: "class 3 B",
    class_name: "class 3",
  },
  {
    timetable_id: 1623,
    section_id: 3,
    day: "Monday",
    period_id: 14,
    subject_id: 4,
    teacher_id: 6,
    created_at: "2025-07-09T06:39:26.000Z",
    period_name: "Period 3",
    start_time: "11:15:00",
    end_time: "12:00:00",
    subject_name: "hindi",
    section_name: "class 3 A",
    class_name: "class 3",
  },

  {
    timetable_id: 1654,
    section_id: 4,
    day: "Monday",
    period_id: 15,
    subject_id: 4,
    teacher_id: 6,
    created_at: "2025-07-09T06:39:26.000Z",
    period_name: "Period 4",
    start_time: "12:00:00",
    end_time: "12:45:00",
    subject_name: "hindi",
    section_name: "class 3 B",
    class_name: "class 3",
  },
  {
    timetable_id: 1596,
    section_id: 2,
    day: "Monday",
    period_id: 18,
    subject_id: 4,
    teacher_id: 6,
    created_at: "2025-07-09T06:39:26.000Z",
    period_name: "Period 6",
    start_time: "14:00:00",
    end_time: "14:45:00",
    subject_name: "hindi",
    section_name: "section 1B",
    class_name: "class 1",
  },
  {
    timetable_id: 1701,
    section_id: 5,
    day: "Thursday",
    period_id: 14,
    subject_id: 4,
    teacher_id: 6,
    created_at: "2025-07-09T06:39:26.000Z",
    period_name: "Period 3",
    start_time: "11:15:00",
    end_time: "12:00:00",
    subject_name: "hindi",
    section_name: "class 3 C",
    class_name: "class 3",
  },
  {
    timetable_id: 1672,
    section_id: 4,
    day: "Thursday",
    period_id: 15,
    subject_id: 4,
    teacher_id: 6,
    created_at: "2025-07-09T06:39:26.000Z",
    period_name: "Period 4",
    start_time: "12:00:00",
    end_time: "12:45:00",
    subject_name: "hindi",
    section_name: "class 3 B",
    class_name: "class 3",
  },
  {
    timetable_id: 1584,
    section_id: 1,
    day: "Thursday",
    period_id: 18,
    subject_id: 4,
    teacher_id: 6,
    created_at: "2025-07-09T06:39:26.000Z",
    period_name: "Period 6",
    start_time: "14:00:00",
    end_time: "14:45:00",
    subject_name: "hindi",
    section_name: "section 1A",
    class_name: "class 1",
  },
  {
    timetable_id: 1628,
    section_id: 3,
    day: "Tuesday",
    period_id: 12,
    subject_id: 4,
    teacher_id: 6,
    created_at: "2025-07-09T06:39:26.000Z",
    period_name: "Period 2",
    start_time: "10:15:00",
    end_time: "11:00:00",
    subject_name: "hindi",
    section_name: "class 3 A",
    class_name: "class 3",
  },
  {
    timetable_id: 1659,
    section_id: 4,
    day: "Tuesday",
    period_id: 14,
    subject_id: 4,
    teacher_id: 6,
    created_at: "2025-07-09T06:39:26.000Z",
    period_name: "Period 3",
    start_time: "11:15:00",
    end_time: "12:00:00",
    subject_name: "hindi",
    section_name: "class 3 B",
    class_name: "class 3",
  },

  {
    timetable_id: 1661,
    section_id: 4,
    day: "Tuesday",
    period_id: 16,
    subject_id: 4,
    teacher_id: 6,
    created_at: "2025-07-09T06:39:26.000Z",
    period_name: "Period 5",
    start_time: "12:45:00",
    end_time: "13:30:00",
    subject_name: "hindi",
    section_name: "class 3 B",
    class_name: "class 3",
  },
  {
    timetable_id: 1692,
    section_id: 5,
    day: "Tuesday",
    period_id: 18,
    subject_id: 4,
    teacher_id: 6,
    created_at: "2025-07-09T06:39:26.000Z",
    period_name: "Period 6",
    start_time: "14:00:00",
    end_time: "14:45:00",
    subject_name: "hindi",
    section_name: "class 3 C",
    class_name: "class 3",
  },
  {
    timetable_id: 1634,
    section_id: 3,
    day: "Wednesday",
    period_id: 12,
    subject_id: 4,
    teacher_id: 6,
    created_at: "2025-07-09T06:39:26.000Z",
    period_name: "Period 2",
    start_time: "10:15:00",
    end_time: "11:00:00",
    subject_name: "hindi",
    section_name: "class 3 A",
    class_name: "class 3",
  },

  {
    timetable_id: 1696,
    section_id: 5,
    day: "Wednesday",
    period_id: 15,
    subject_id: 4,
    teacher_id: 6,
    created_at: "2025-07-09T06:39:26.000Z",
    period_name: "Period 4",
    start_time: "12:00:00",
    end_time: "12:45:00",
    subject_name: "hindi",
    section_name: "class 3 C",
    class_name: "class 3",
  },
  {
    timetable_id: 1607,
    section_id: 2,
    day: "Wednesday",
    period_id: 16,
    subject_id: 4,
    teacher_id: 6,
    created_at: "2025-07-09T06:39:26.000Z",
    period_name: "Period 5",
    start_time: "12:45:00",
    end_time: "13:30:00",
    subject_name: "hindi",
    section_name: "section 1B",
    class_name: "class 1",
  },
  {
    timetable_id: 1668,
    section_id: 4,
    day: "Wednesday",
    period_id: 18,
    subject_id: 4,
    teacher_id: 6,
    created_at: "2025-07-09T06:39:26.000Z",
    period_name: "Period 6",
    start_time: "14:00:00",
    end_time: "14:45:00",
    subject_name: "hindi",
    section_name: "class 3 B",
    class_name: "class 3",
  },
  {
    timetable_id: 1668,
    section_id: 4,
    day: "Saturday",
    period_id: 14,
    subject_id: 4,
    teacher_id: 6,
    created_at: "2025-07-09T06:39:26.000Z",
    period_name: "Period 6",
    start_time: "11:15:00",
    end_time: "12:00:00",
    subject_name: "hindi",
    section_name: "class 3 B",
    class_name: "class 3",
  },
];

export default timetableData;
